import { render } from "./InteriorCheck.vue?vue&type=template&id=0a502485&scoped=true&ts=true"
import script from "./InteriorCheck.vue?vue&type=script&lang=ts"
export * from "./InteriorCheck.vue?vue&type=script&lang=ts"

import "./InteriorCheck.vue?vue&type=style&index=0&id=0a502485&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a502485"]])

export default __exports__